import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { selectedQueueTickets } from 'features/queue/slice';
import { postSearchSrRequest } from 'services/ticketService';
import { mergeTableColumnConfigs } from './useMergeTableColumns';

const useMergeTableData = () => {
  const selectedTickets = useSelector(selectedQueueTickets);
  const includedSrIds = useMemo(() => (selectedTickets ? selectedTickets.map((e) => e.id) : []), [selectedTickets]);

  const searchSrRequest = useMemo(
    () => ({
      columnConfiguration: mergeTableColumnConfigs,
      filters: [
        {
          fieldId: 2,
          field: 'id',
          values: includedSrIds,
          name: 'id',
          type: 'equals',
          fieldType: {
            id: 1,
            typeName: 'number',
          },
          displayKeys: includedSrIds,
          customColumn: false,
        },
      ],
      from: 0,
      limit: includedSrIds?.length,
    }),
    [includedSrIds],
  );

  const queryFn = async () => {
    try {
      const response = await postSearchSrRequest(searchSrRequest);
      return response;
    } catch (e) {
      console.error(e);
    }
  };

  const { data, isFetched } = useQuery({
    queryKey: ['mergeTableSearch', includedSrIds],
    queryFn,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { data, isFetched };
};

export default useMergeTableData;
